import styled from "styled-components";
export const InnerBGWrap = styled.div`
margin:0 auto;
  width: 93.7%;
  padding-top: ${({ width, height }) => `${(height / width) * 100}%`};
  border-top: none;
  border-bottom: none;
  box-sizing: border-box;
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
  position: relative;
  top:0;
`;


